import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { submitQuestion } from '../../../services/api';
import SharePanel from '../../components/SharePanel';
import FixBottom from '../../components/FixBottom';

const Layout = ({ content }) => {
    const shareUrl = typeof window === 'undefined' ? '' : window.location.href.replace('news.ifeng.com', 'ishare.ifeng.com');
    const industryConfig = [
        {
            name: '汽车制造与智能出行',
            titleImage: 'https://x0.ifengimg.com/ucms/2026_10/DA3C60198D291735A82750CDAA1BDA516BFC38A2_size192_w1420_h144.png',
        },
        {
            name: '智能家电与消费电子',
            titleImage: 'https://x0.ifengimg.com/ucms/2026_10/E5E69B0CD14363D106DEEA5A9D8AA1D497B237A0_size191_w1420_h144.png',
        },
        {
            name: '绿色能源与光伏锂电',
            titleImage: 'https://x0.ifengimg.com/ucms/2026_10/4A8F5F362F42B31D7AAC88A6E374634F656315E7_size193_w1420_h144.png',
        },
        {
            name: '数字安全与智能装备',
            titleImage: 'https://x0.ifengimg.com/ucms/2026_10/FE1A8E271E0A09C52FFFD8589285BECB6439753E_size193_w1420_h144.png',
        },
    ];
    const entrepreneursList = (content && content.entrepreneursList) || [];

    const [isPopVisible, setIsPopVisible] = useState(false);
    const [popMode, setPopMode] = useState('single');
    const [isSubmitSuccessVisible, setIsSubmitSuccessVisible] = useState(false);
    const redirectTimerRef = useRef(null);
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        clearErrors,
        formState: { errors },
    } = useForm({
        shouldUnregister: true,
    });
    const [selectedPersonName, setSelectedPersonName] = useState('');

    const openSingleQuestionPop = (personName = '') => {
        setPopMode('single');
        setSelectedPersonName(personName);
        setIsSubmitSuccessVisible(false);
        setIsPopVisible(true);
        reset();
        setValue('targetPerson', personName);
        clearErrors();
    };

    const openDoubleQuestionPop = () => {
        setPopMode('double');
        setSelectedPersonName('');
        setIsSubmitSuccessVisible(false);
        setIsPopVisible(true);
        reset();
        setValue('targetPerson', '');
        clearErrors();
    };

    const closePop = () => {
        setIsPopVisible(false);
        setSelectedPersonName('');
        setIsSubmitSuccessVisible(false);
        reset();
        clearErrors();
    };

    useEffect(
        () => () => {
            if (redirectTimerRef.current) {
                clearTimeout(redirectTimerRef.current);
            }
        },
        []
    );

    const getCategoryUrl = (name) => {
        if (typeof window === 'undefined') {
            return '';
        }
        const baseUrl = window.location.href.split('?')[0].replace(/\/$/, '');
        const query = name ? `?name=${encodeURIComponent(name)}` : '';
        return `${baseUrl}/category${query}`;
    };

    const goToCategoryPage = (name) => {
        const categoryUrl = getCategoryUrl(name);
        if (categoryUrl) {
            window.location.href = categoryUrl;
        }
    };

    const handleContentClick = (event) => {
        const target = event.target;
        if (!target.classList || !target.classList.contains(styles.titlePic)) {
            return;
        }
        if (!target.closest(`.${styles.peopleImage}`)) {
            return;
        }
        const peopleName = target.getAttribute('data-person-name') || '';
        goToCategoryPage(peopleName);
    };

    const onSubmit = async (formData) => {
        const entrepreneurName = (formData.targetPerson || selectedPersonName || '').trim().slice(0, 64);
        const question = (formData.question || '').trim().slice(0, 110);
        const payload = {
            entrepreneur_name: entrepreneurName,
            question,
            source: popMode === 'single' ? 1 : 2,
        };

        try {
            const response = await submitQuestion(payload);
            if (response && response.data && response.data.code === 0) {
                if (popMode === 'double') {
                    closePop();
                } else {
                    setIsPopVisible(false);
                    setIsSubmitSuccessVisible(true);
                    if (redirectTimerRef.current) {
                        clearTimeout(redirectTimerRef.current);
                    }
                    redirectTimerRef.current = setTimeout(() => {
                        goToCategoryPage(entrepreneurName);
                    }, 2000);
                }
            }
        } catch (error) {
            // 保留错误日志，避免提交失败时静默
            console.error('submit question failed:', error);
        }
    };

    const handlePeopleButtonClick = (event) => {
        const target = event.target;
        if (!target.classList || !target.classList.contains(styles.titleButton)) {
            return;
        }
        event.preventDefault();
        const peopleBox = target.closest(`.${styles.peopleImage}`);
        const peoplePic = peopleBox ? peopleBox.querySelector(`.${styles.titlePic}`) : null;
        const peopleName = peoplePic ? peoplePic.getAttribute('data-person-name') || '' : '';
        openSingleQuestionPop(peopleName);
    };

    return (
        <div className={styles.layout}>
            <SharePanel
                title="时代问答︱2026全国两会，邀你提问企业家代表委员"
                desc="你的问题，将有机会被记者带到两会现场。"
                img="https://x0.ifengimg.com/ucms/2026_10/788C6F9203DE506675AC49CFE9D738227B9B7657_size103_w300_h300.png"
                url={shareUrl}
            />
            <div className={styles.content} onClick={handleContentClick}>
                <div className={styles.quote}>
                    人工智能等高端科技正在深刻影响我们的生活。2026全国两会，凤凰网资讯聚焦于AI、能源、智造等领域的企业家代表委员。他们会如何“向新而生，向优而行”？这一次，由你来提问。你的问题，将有机会被记者带到两会现场。
                </div>
                {industryConfig.map((industryItem) => {
                    const categoryData = entrepreneursList.find((item) => item.name === industryItem.name) || {};
                    const categoryPeopleList = categoryData.list || [];

                    return (
                        <div className={styles.module} key={industryItem.name}>
                            <div className={styles.moduleTitle}>
                                <img className={styles.moduleTitlePic} src={industryItem.titleImage} alt={industryItem.name} />
                            </div>
                            <div className={styles.moduleBox} onClick={handlePeopleButtonClick}>
                                {categoryPeopleList.map((person) => (
                                    <div className={styles.peopleImage} key={person.name}>
                                        <img className={styles.titlePic} src={person.headimg_h5} data-person-name={person.name} alt={person.name} />
                                        <div>
                                            <img className={styles.titleButton} src="https://x0.ifengimg.com/ucms/2026_10/15C96FC68B5AD8975702E1CC03AAEF333F70EEFF_size39_w360_h128.png" alt="" />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    );
                })}
                <div className={styles.tip}>
                    <img className={styles.tipPic} src="https://x0.ifengimg.com/ucms/2026_10/73AA393675A4F0818AF08E97502DDF60B5F1145E_size11_w704_h104.png" />
                </div>
                <div className={styles.otherPeople}>
                    <img className={styles.otherPeoplePic} src="https://x0.ifengimg.com/ucms/2026_10/0D648C2C40049BB8B8A50DD8D71CE8D30665A967_size15_w1040_h66.png" />
                </div>
                <div className={styles.otherPeopleButton} onClick={openDoubleQuestionPop}>
                    <img className={styles.otherPeopleButtonPic} src="https://x0.ifengimg.com/ucms/2026_10/0A59087BC4E9448FB58E44B6A7B28256165F4D0F_size122_w1100_h220.png" alt="" />
                </div>
            </div>
            <div className={styles.pageFooter}>
                <img className={styles.pageFooterPic} src="https://x0.ifengimg.com/ucms/2026_10/DC617B370763579066A81279D411469673FA3D04_size615_w1500_h720.png" />
            </div>
            {isPopVisible && (
                <div className={styles.pagePopBox}>
                    <form className={styles.pagePop} onSubmit={handleSubmit(onSubmit)}>
                        <div className={styles.pagePopHead}>
                            <img className={styles.pagePopHeadPic} src="https://x0.ifengimg.com/ucms/2026_10/114190A1ADB103372179B7C5DF0FF7E37B959A87_size45_w492_h120.png" alt="" />
                        </div>
                        <div className={styles.pagePopContent}>
                            {popMode === 'double' && (
                                <>
                                    <div className={styles.pagePopQuestion}>1、你想提问哪位企业家代表委员？</div>
                                    <div className={styles.pagePopInput1}>
                                        <input
                                            className={styles.pagePopInput1Text}
                                            placeholder="点击输入你想问的企业家名字"
                                            {...register('targetPerson', {
                                                required: '请填写提问对象',
                                                maxLength: {
                                                    value: 64,
                                                    message: '企业家姓名最多64个字符',
                                                },
                                            })}
                                        />
                                    </div>
                                    {errors.targetPerson && <div className={styles.pagePopError}>{errors.targetPerson.message}</div>}
                                </>
                            )}
                            <div className={styles.pagePopQuestion}>{popMode === 'double' ? '2、你最想问TA什么问题？' : '你想问TA什么问题？'}</div>
                            <div className={styles.pagePopInput2}>
                                <textarea
                                    className={styles.pagePopInput2Text}
                                    placeholder="点击输入你想问的问题"
                                    {...register('question', {
                                        required: '请填写问题内容',
                                        maxLength: {
                                            value: 110,
                                            message: '问题内容最多110个字符',
                                        },
                                    })}
                                />
                            </div>
                            {errors.question && <div className={styles.pagePopError}>{errors.question.message}</div>}
                        </div>
                        <button type="submit" className={styles.pagePopSubmit} />
                        <div className={styles.pagePopClose} onClick={closePop} />
                    </form>
                </div>
            )}
            {isSubmitSuccessVisible && (
                <div className={styles.pageToastBox}>
                    <div className={styles.pagePopToast}>提交成功，提问已收录！</div>
                </div>
            )}
            <FixBottom />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
